import type { SVGProps } from 'react';

const SvgLooksTwo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M21 3H3v18h18zm-6 10h-4v2h4v2H9v-6h4V9H9V7h6z" />
  </svg>
);
export default SvgLooksTwo;
